import { Reducer } from "redux";

import { UserMfaInfoActionDispatchTypes } from "../constants/User";
import { UserMfaInfoResponse } from "../models/api/User";
import { UserSendMfaInfoActionTypes } from "../models/dispatchTypes/User";

export const initialState: UserMfaInfoResponse = {
  loading: false,
  response: {
    userId: "",
    email: "",
    status: ""
  },
  error: null,
};

const UserSendMfaInfoReducer: Reducer<
UserMfaInfoResponse,
UserSendMfaInfoActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case UserMfaInfoActionDispatchTypes.USER_SEND_MFA_CODE_LOADING: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case UserMfaInfoActionDispatchTypes.USER_SEND_MFA_CODE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: null,
      };
    }
    case UserMfaInfoActionDispatchTypes.USER_SEND_MFA_CODE_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }
    case UserMfaInfoActionDispatchTypes.USER_SEND_MFA_CODE_RESET: {
      return initialState;
    }
  }
  return state;
};

export default UserSendMfaInfoReducer;